<template>
  <div class="card quadroshadow border-0 m-3">
    <div class="row card-body p-3 m-0">
      <img
        v-if="item.course.thumbnail"
        class="col-sm-4 p-0 m-0 rounded"
        height="200"
        :src="`${ api_url }${ item.course.thumbnail.url }`"
      />

      <div class="col-sm-8 pt-2 pl-0">
        <h5 class="card-title pl-3 mb-0"><b>{{ item.course.name }}</b></h5>
        <p class="card-text pl-3 teacher"><user-data :user="item.course.user" /></p>

        <br>
        <div class="row pl-md-2 pl-lg-2">
          <div class="col text-left pl-4">
            <button type="button" class="btn btn-secondary mr-sm-2 mb-md-0 mb-2" @click="goToShowTime()">Acessar aulas</button>

            <a
              v-if="item.payment_form != 'FR'"
              type="button"
              class="btn btn-secondary"
              :class="{
                'disabled': item.progress < 95
              }"
              target="_blank"
              :href="certificationLink(item)"
            >
              Gerar Certificado
            </a>
          </div>

          <div class="status">
            <p v-if="item.status_payment == 'P'" class="text-white p-1 bg-secondary mt-2 ml-2 rounded text-center mb-0 payment-status"><b>Processando a compra</b></p>
            <p v-else-if="item.status_payment == 'W'" class="text-dark p-1 bg-warning rounded text-center mt-2 ml-2 payment-status"><b>Aguardando confirmação de pagamento</b></p>
            <p v-else-if="item.status_payment == 'X'" class="text-white p-1 bg-dark mt-2 ml-2 rounded text-center mb-0 payment-status"><b>Compra cancelada</b></p>

            <div class="mt-2" v-else-if="item.status_payment == 'S'">
              <div class="row">
                <div class="w-15">
                  <div class="progre">{{item.progress}}%</div>
                </div>
                <div class="col">
                  <div class="progress rounded-5 m-2" style="height:10px">
                    <div
                      class="progress-bar progress-bar bg-success"
                      role="progressbar"
                      :style="`width:${item.progress}%`"
                      :aria-valuenow="item.progress"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserData from './User/UserData';
import CourseValues from './Values'
import Axios from 'axios';
import { getCookie } from '@/cookiesHandler'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE
    }
  },
  computed: {

  },
  components: {
    "user-data": UserData,
    "course-values": CourseValues
  },
  methods: {
    goToShowTime: function() {
      window.open(`/showtime/${ this.item.user_link }`, '_blank')
    },

    certificationLink: function (item) {
      let token = getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00')
      return `${process.env.VUE_APP_REPORT}/student/certification/${item.user_link}?token=${token}`
    },
    generateCertification: function () {

    },
    cancel: function () {
      Axios.delete('/my/courses/cancel', {
        course: this.item.id,
        token: Math.random()
      })
        .then( res => {
          this.item.status_payment = 'X'
        })
        .catch( err => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .payment-status {
    font-size: 16px;
  }

  .status {
    margin: 10px 0px 0px 10px;
    bottom: 0;
    width: 100%;
  }

  .quadroshadow {
    border-radius: 10px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  }
  .botoes {
    justify-content: center;
    align-items: center;
  }
  .progre {
    color: green;
    padding-left: 30px;
  }
</style>
